"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementGenerator = void 0;
var countries_const_1 = require("./const/countries.const");
var generator_const_1 = require("./const/dom-crud/generator.const");
var guardian_const_1 = require("./const/forms/guardian.const");
var input_output_helper_const_1 = require("./const/input-output-helper.const");
var input_mapping_const_1 = require("./const/input.mapping.const");
var translation_1 = __importDefault(require("./services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var ElementGenerator = /** @class */ (function () {
    function ElementGenerator() {
        this.theme = {
            success: {
                background: '#a7f8a8',
                color: '#333',
            },
            info: {
                background: 'rgb(158, 196, 255)',
                color: '#333',
            },
            error: {
                background: '#ffdcd7',
                color: '#333',
            },
            transparent: {
                color: '#333',
            },
        };
        // const searchInput = $('<input>')
        //   .attr('placeholder', 'Search country...')
        //   .addClass('search-input');
        // const selectElem = $('<select>').addClass('country-dropdown');
        // appendTo.append(searchInput).append(selectElem);
        // // Event listener for search functionality
        // searchInput.on('keyup', function () {
        //   const searchTerm = $(this).val()?.toString().toLowerCase();
        //   $('option', selectElem).each(function () {
        //     const text = $(this).text().toLowerCase();
        //     if (text.includes(searchTerm!)) {
        //       $(this).show();
        //     } else {
        //       $(this).hide();
        //     }
        //   });
        //   // Show the dropdown
        //   selectElem.show();
        // });
    }
    /**
     *
     * @param obj generator {html:text,css:obj,class:string}
     * @param type 'success' | 'error' | 'info' | 'transparent'
     * @param attr custom attributes {data-get:12345}
     * @returns
     */
    ElementGenerator.prototype.getRow = function (obj, type, attr) {
        var _a;
        if (attr === void 0) { attr = {}; }
        var theme = {};
        if (type === null || type === void 0 ? void 0 : type.length) {
            theme = __assign({ padding: '15px', margin: '20px 0px', borderRadius: '5px' }, this.theme[type]);
        }
        return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass('m-row' + ((obj === null || obj === void 0 ? void 0 : obj.class) ? ' ' + obj.class : ''))
            .attr(attr)
            .css(__assign(__assign({ width: '100%', display: 'flex', alignItems: 'center' }, theme), obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.getCol = function (colSize, obj) {
        var _a;
        return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass('m-col-' + colSize)
            .css(__assign({ width: 'calc(100% / ' + colSize + ')' }, obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.getDividerLine = function () {
        return (0, cash_dom_1.default)('<div></div>').addClass('divider-line margin');
    };
    ElementGenerator.prototype.getGeneric = function (obj) {
        var _a;
        return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass((obj === null || obj === void 0 ? void 0 : obj.class) || '')
            .css(__assign({}, obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.twoColSetup = function (leftSide, rightSide, css) {
        var row = this.getRow();
        row.append(this.getCol(2, { html: leftSide, css: css }));
        row.append(this.getCol(2, {
            html: rightSide,
            css: __assign({ textAlign: 'right' }, css),
        }));
        return row;
    };
    ElementGenerator.prototype.createElements = function () {
        this.getPhonePrefixDropdown();
        this.getCountryDropdown();
    };
    ElementGenerator.prototype.getPhonePrefixDropdown = function () {
        var dataset = countries_const_1._COUNTRIES.map(function (country) { return (__assign({ text: "".concat(translation_1.default.t(country.name), " (").concat(country.prefix, ")") }, country)); });
        return (0, generator_const_1._CreateDropdown)('phone', 'prefix', dataset, function (country) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.phonePrefix, country.prefix);
        });
    };
    ElementGenerator.prototype.getGuardianPhonePrefixDropdown = function () {
        var dataset = countries_const_1._COUNTRIES.map(function (country) { return (__assign({ text: "".concat(translation_1.default.t(country.name), " (").concat(country.prefix, ")") }, country)); });
        return (0, generator_const_1._CreateDropdown)('guardianPhone', 'prefix', dataset, function (country) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(guardian_const_1._GuardianTelephoneMobilePrefix, country.prefix);
        });
    };
    ElementGenerator.prototype.getCountryDropdown = function () {
        var dataset = countries_const_1._COUNTRIES.map(function (country) { return (__assign({ text: "".concat(translation_1.default.t(country.name), " (").concat(country.isoCode, ")") }, country)); });
        return (0, generator_const_1._CreateDropdown)('country', 'isoCode', dataset, function (country) {
            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.countryCode, country.isoCode);
        });
    };
    return ElementGenerator;
}());
exports.ElementGenerator = ElementGenerator;
